/**
 * The auth package writes the signed-in user into localStorage under "user";
 * the host page and every app read it from there.
 */
const STORAGE_KEY = "user";

export type StoredUserInfo = {
  id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  company?: {
    name?: string | null;
  } | null;
};

type StoredUser = {
  data?: StoredUserInfo;
};

export const getStoredUser = (): StoredUserInfo | null => {
  const userData = localStorage.getItem(STORAGE_KEY);
  if (!userData) {
    return null;
  }

  try {
    return (JSON.parse(userData) as StoredUser).data ?? null;
  } catch {
    return null;
  }
};

export const clearStoredUser = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
